import { css, Global } from '@emotion/react';

export const AntdGlobalStyles = (): JSX.Element => {
  // const theme = useTheme();
  return (
    <Global
      styles={css`
        .red {
          color: red;
        }
        // TODO - show image gallery controls only on hover
        // .image-gallery-image-container :hover {
        //   // display: none;
        //   .gallery-bottom-controls {
        //     display: block;
        //   }
        // }
      `}
    />
  );
};
